import React from "react";
const SvgGoFullScreen = props => (
  <svg viewBox="0 0 16 16" {...props}>
    <path
      fill="none"
      stroke="#1A1F24"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11.889 1H15v3.111m-4.667 1.556L15 1M4.111 15H1v-3.111m4.667-1.556L1 15m.778-7.778V3.333c0-.86.696-1.555 1.555-1.555h3.89m7 7v3.889c0 .86-.697 1.555-1.556 1.555H8"
    />
  </svg>
);
export default SvgGoFullScreen;
